import {ALTER_DISABLED_STATUS_OF_INPUTBOX} from './actionTypes'

export const alterInputBoxDisabledStatus = (payload) =>
{
    return {
        type : ALTER_DISABLED_STATUS_OF_INPUTBOX,
        payload
    }
};


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/lib-inputbox-toggle/lib/actions/actions.js